import {
    LayoutDashboard,
    FolderKanban,
    Wallet,
    ChartSpline,
    Settings2,
    Building2,
    Zap,
    ClipboardList,
    TrendingUp,
    ArrowRightLeft,
    DollarSign,
    Sparkles
} from "lucide-react"
import type { NavItem } from "@/types/nav"

export const companyAdminNav: NavItem[] = [
    {
        title: "Dashboard",
        url: "/dashboard/company-admin/dashboard/overview",
        icon: LayoutDashboard,
    },
    {
        title: "Manage",
        url: "/dashboard/company-admin/manage",
        icon: FolderKanban,
        items: [
            // {
            //     title: "Status Overview",
            //     url: "/dashboard/company-admin/manage/status-overview",
            // },
            {
                title: "Properties",
                url: "/dashboard/company-admin/manage/properties",
            },
            {
                title: "Utilities",
                url: "/dashboard/company-admin/manage/utilities",
            },
            // {
            //     title: "Work Orders",
            //     url: "/dashboard/company-admin/manage/work-orders",
            // }
        ],
    },
    {
        title: "Financials",
        url: "/dashboard/company-admin/financials",
        icon: DollarSign,
        items: [
            {
                title: "Invoices",
                url: "/dashboard/company-admin/financials/invoices",
            },
            {
                title: "Funding",
                url: "/dashboard/company/funding-history",
            },
            {
                title: "Reconciliation",
                url: "/dashboard/company/accounting-statements",
            },
            {
                title: "Fees",
                url: "/dashboard/company-admin/financials/fees",
            }
        ],
    },
    {
        title: "Reports",
        url: "/dashboard/company-admin/reports",
        icon: ChartSpline,
        items: [
            {
                title: "Spikes",
                url: "/dashboard/company-admin/reports/spike-detection",
            },
            {
                title: "Bill Pay Performance",
                url: "/dashboard/company-admin/reports/bill-pay-performance",
            }
        ],
    },
    {
        title: "AI Tools",
        url: "/dashboard/ai-tools",
        icon: Sparkles,
        items: [
            {
                title: "Fee Analyzer",
                url: "/dashboard/ai-tools/fee-analyzer",
            }
        ],
    },
    {
        title: "Settings",
        url: "/dashboard/settings",
        icon: Settings2,
        items: [
            {
                title: "Company Information",
                url: "/dashboard/settings/company",
            },
            {
                title: "Members",
                url: "/dashboard/settings/members",
            },
            {
                title: "Entity Bank Accounts",
                url: "/dashboard/settings/bank",
            },
            {
                title: "Spike Alert Thresholds",
                url: "/dashboard/settings/spike-alert",
            },
            {
                title: "Notifications",
                url: "/dashboard/settings/notifications",
            }
        ],
    }
]

